import { createApp, isVue3 } from "vue-demi";
import DevModeInfo from "./components/DevModeInfo.vue";
import consoleBuildInfoLogger from "./consoleBuildInfoLogger.mjs";
const DevToolsPlugin = {
  install(app, pluginOptions) {
    if (typeof pluginOptions?.buildInfo !== "object" || Object.keys(pluginOptions.buildInfo).length === 0) {
      return console.info("Unable to setup devtools plugin because of missing config.");
    }
    const options = {
      consoleOnly: true,
      ...pluginOptions
    };
    consoleBuildInfoLogger(options.buildInfo);
    if (options.consoleOnly) return;
    if (isVue3) {
      const app2 = createApp(DevModeInfo, options.buildInfo);
      const componentInstance = app2.mount(document.createElement("div"));
      document.body.appendChild(componentInstance.$el);
    } else {
      const ComponentConstructor = app.extend(DevModeInfo);
      const componentInstance = new ComponentConstructor({
        propsData: options.buildInfo
      });
      componentInstance.$mount();
      document.body.appendChild(componentInstance.$el);
    }
  }
};
export default DevToolsPlugin;
